import { PMessage } from 'components/prime/PMessage/PMessage';
import styled from 'styled-components';
import { colourPalette, fontSize, lineHeight } from 'styles/styles';

export const LoginFormStyle = {
  Form: styled.form`
    width: 100%;
  `,
  Footer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  Title: styled.h4`
    margin: 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 18px;
    color: ${colourPalette.neutral900};
    margin-bottom: 16px;
  `,
  Subtitle: styled.h4`
    margin: 0;
    font-weight: 400;
    font-size: ${fontSize.fontSizeSM};
    line-height: ${lineHeight.lineHeightMD};
    color: ${colourPalette.neutral500};
    margin-bottom: 32px;
  `,
  Message: styled(PMessage)`
    margin-bottom: 24px;
  `,
  Divider: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    & > div {
      flex: 1;
      border-bottom: 1px solid ${colourPalette.neutral300};
    }
    span {
      color: ${colourPalette.neutral400};
    }
  `,
};
